import { ACTIVE, HIDDEN } from '../classnames/design-system';
import SideMenu from '../navigation/side-menu';
import {
  SIDEBAR_POPUP_ITEM,
  SIDEBAR_POPUP_CONTAINER,
  SIDEBAR_POPUP_CTA_BUTTON,
  SIDE_MENU_TABS,
  SIDE_MENU_TABS_BUTTON,
  SIDE_MENU_TABS_CONTENT,
  SIDE_MENU
} from '../classnames/sidebar-popup';

export default class SidebarPopup {
  constructor() {
    this.sideMenu = new SideMenu();
    this.containers = document.querySelectorAll(`.${SIDEBAR_POPUP_CONTAINER}`);
  }

  initializeTabsHandler = (popup) => {
    const tabButtons = popup.querySelectorAll(`.${SIDE_MENU_TABS_BUTTON}`);
    const tabContents = popup.querySelectorAll(`.${SIDE_MENU_TABS_CONTENT}`);

    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        const { tabId } = tabButton.dataset;

        tabButtons.forEach((button) => {
          button.classList.toggle(ACTIVE, button.dataset.tabId === tabId);
        });

        tabContents.forEach((content) => {
          content.classList.toggle(HIDDEN, content.dataset.contentId !== tabId);
        });
      });
    });
  };

  initializeEventListeners = () => {
    this.sideMenu.initializeEventListeners();
    this.containers.forEach((container) => {
      const items = container.querySelectorAll(`.${SIDEBAR_POPUP_ITEM}`);

      items.forEach((item) => {
        const { itemId, closeId } = item.dataset;

        item.addEventListener('click', () => {
          this.sideMenu.hideAll();
          this.sideMenu.show(itemId);
        });

        const closeButton = document.getElementById(closeId);
        const ctaButtons = document.querySelectorAll(`.${SIDEBAR_POPUP_CTA_BUTTON}`);

        if (closeButton) {
          closeButton.addEventListener('click', () => this.sideMenu.hide(itemId));

          ctaButtons.forEach((ctaButton) => {
            ctaButton.addEventListener('click', () => this.sideMenu.hide(itemId));
          });
        }
      });
    });

    this.containers.forEach((container) => {
      const popups = container.querySelectorAll(`.${SIDE_MENU}`);

      [...popups].forEach((popup) => {
        const tabsContainers = popup.querySelectorAll(`.${SIDE_MENU_TABS}`);

        if (tabsContainers.length === 0) {
          return;
        }

        this.initializeTabsHandler(popup);
      });
    });
  };
}
